import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';
import styled, { css } from 'styled-components';

interface IProps {
  className: string;
  $size?: string | number;
  $weight?: string | number;
  $lineHeight?: string | number;
  $letterSpacing?: string | number;
  $color?: string;
  $align?: string;
  $underline?: boolean;
  $del?: boolean;
  $ellipsis?: number;
}

export const Text = styled.span<IProps>`
  font-size: ${({ $size }) =>
    typeof $size === 'number' ? `${$size}px` : $size};
  line-height: ${({ $lineHeight }) =>
    typeof $lineHeight === 'number' ? `${$lineHeight}px` : $lineHeight};
  letter-spacing: ${({ $letterSpacing }) =>
    typeof $letterSpacing === 'number'
      ? `${$letterSpacing}px`
      : $letterSpacing};
  color: ${({ $color }) => $color};
  text-align: ${({ $align }) => $align};
  text-decoration: ${({ $underline, $del }) =>
    !$del && $underline ? 'underline' : undefined};
  font-weight: ${({ $weight }) => $weight};

  ${props => {
    if (props.$ellipsis !== 0) {
      return css`
        ${mixin.ellipsis(props.$ellipsis)}
      `;
    }
    return null;
  }}

  em,strong {
    font-weight: inherit;
  }

  @media ${({ theme }) => theme.media.smMax} {
    font-size: ${({ $size }) =>
      typeof $size === 'number' ? `${mixin.pxToVw(String($size))}` : $size};
    line-height: ${({ $lineHeight }) =>
      typeof $lineHeight === 'number'
        ? `${mixin.pxToVw(String($lineHeight))}`
        : $lineHeight};
  }
`;
